import { Shirt, MessageSquare, Sparkles } from 'lucide-react'

const steps = [
    {
        icon: Shirt,
        title: 'Add your clothes',
        description: 'Snap photos of what you own. Works with as few as 10-15 items — takes just a few minutes to set up.',
    },
    {
        icon: MessageSquare,
        title: 'Describe the occasion',
        description: '"Dinner with friends tonight" or "Monday morning meeting" — that\'s all Michela needs to know.',
    },
    {
        icon: Sparkles,
        title: 'Get 3 outfit options',
        description: 'Michela builds complete outfits from your wardrobe, explains why each works, and offers virtual try-on.',
    },
]

export function HowItWorks() {
    return (
        <section className="py-24 sm:py-32 bg-paper-alt relative overflow-hidden">
            {/* Subtle background element */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none opacity-40">
                <div className="absolute top-1/4 left-0 w-64 h-64 bg-accent-subtle/20 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 right-0 w-64 h-64 bg-accent-subtle/20 rounded-full blur-3xl" />
            </div>

            <div className="max-w-5xl mx-auto px-8 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16 sm:mb-24">
                    <h2 className="font-display text-4xl sm:text-5xl font-semibold text-ink mb-6">
                        How it works
                    </h2>
                    <p className="text-ink-tertiary text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed px-6 sm:px-0">
                        Getting dressed shouldn't be the hardest part of your day.
                    </p>
                </div>

                <div className="relative">
                    {/* Desktop Horizontal Line */}
                    <div className="hidden sm:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-paper-tertiary to-transparent" />

                    <div className="grid sm:grid-cols-3 gap-16 sm:gap-16">
                        {steps.map((step, index) => (
                            <div key={step.title} className="relative group">
                                {/* Mobile Vertical Line - centered for zigzag transition */}
                                {index < steps.length - 1 && (
                                    <div className="sm:hidden absolute top-24 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-paper-tertiary to-transparent" />
                                )}

                                <div className={`flex flex-col sm:block items-center`}>
                                    <div className={`flex items-center gap-6 sm:block w-full sm:w-auto sm:text-center ${
                                        index % 2 === 1 ? 'flex-row-reverse text-right' : 'flex-row text-left'
                                    }`}>
                                        {/* Icon container */}
                                        <div className="relative flex-shrink-0 inline-flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 mb-0 sm:mb-8 bg-paper rounded-[1.5rem] sm:rounded-[2rem] border border-paper-tertiary shadow-sm transition-all duration-300 group-hover:border-accent-subtle group-hover:shadow-md">
                                            <step.icon className="w-8 h-8 sm:w-10 sm:h-10 text-ink" strokeWidth={1.25} />
                                            
                                            {/* Step number badge */}
                                            <div className="absolute -top-2 -right-2 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-ink text-white text-xs sm:text-sm font-semibold flex items-center justify-center border-4 border-paper-alt">
                                                {index + 1}
                                            </div>
                                        </div>

                                        <div className="flex-1">
                                            <h3 className="font-display text-xl sm:text-2xl font-semibold text-ink mb-2 sm:mb-3">
                                                {step.title}
                                            </h3>
                                            <p className="text-ink-tertiary leading-relaxed text-[15px] sm:text-base">
                                                {step.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
